import { render, staticRenderFns } from "./IoItem.vue?vue&type=template&id=2bf2ee84&scoped=true&"
import script from "./IoItem.vue?vue&type=script&lang=js&"
export * from "./IoItem.vue?vue&type=script&lang=js&"
import style0 from "./IoItem.vue?vue&type=style&index=0&id=2bf2ee84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2ee84",
  null
  
)

export default component.exports